import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import styles from './InfoIcon.module.scss';

const InfoIcon = (props: DetailedHTMLProps<HTMLAttributes<SVGElement>, SVGElement>) => {
    return <FaInfoCircle {...props} className={`${styles.icon} ${props.className ?? ''}`} />
}

export default InfoIcon;
